import Vue from "vue"
import $http from "./http"

const freeze = (r) => Object.freeze(r)

const list2tree = (data = []) => {
    const result = [];
    const hash = {};
    const len = data.length;
    const id = "id";
    const pid = "parentId";
    const children = "children";
    for (let i = 0; i < len; i++) {
        hash[data[i][id]] = data[i];
    }
    for (let j = 0; j < len; j++) {
        const aVal = data[j];
        const hashVP = hash[aVal[pid]];
        if (hashVP) {
            if (!hashVP[children]) { hashVP[children] = []; }
            aVal.level = hashVP.level + 1;
            hashVP[children].push(aVal);
        } else {
            aVal.level = 0;
            result.push(aVal);
        }
    }
    return result;
}

const store = Vue.observable({
    debug: true,
    size: 20,
    state: {
        users: [],
        addrs: [],
        devs: [],
        addrTree: []
    },
    _init() {
        
    },
})

function install(Vue) {
    Vue.prototype.$store = store;
    store._init()
}

export default {
    install
}